const init = () => {
  const countUpList = document.querySelectorAll('[data-countupvalue]');
  
  if (countUpList.length) {
    let whenToStart = 0.5;
    countUpList.forEach(countUp => {
      let observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio >= whenToStart) {
              initScrollCheck(countUp);
            }
          });
        },
        { threshold: 1 },
      );
      observer.observe(countUp);
    });
  }
};

const initScrollCheck = countUp => {
  if (!countUp.classList.contains('finished')) {
    animateValue(countUp);
  }
};

const animateValue = countUp => {
  if (!countUp.classList.contains('finished')) {
    countUp.classList.add('finished');
    var timeOut = 0;
    setTimeout(function (e) {
      const maxValue = parseInt(countUp.getAttribute('data-countupvalue'));
      loop(0, countUp, maxValue);
    }, timeOut);
  }
};

const loop = (i, element, max) => {
  const timeOut = 35;
  const countUpScaler = max / 100;
  setTimeout(function () {
    if (i >= max) {
      element.innerHTML = max;
    } else {
      element.innerHTML = Math.round(i);
      i += countUpScaler;
      loop(i, element, max);
    }
  }, timeOut);
};

const countUpAnimation = {
  init,
};

export default countUpAnimation;
